import { http, HttpResponse } from 'msw';
import { faker } from '@faker-js/faker';
import { Campaign } from '@core/models/campaign.model';

export const campaignHandlers = [
  // Get campaigns list
  http.get(`${import.meta.env.VITE_API_URL}/campaign`, () => {
    const mockCampaigns = Array.from({ length: 3 }).map((_, idx) => {
      const initDate = faker.date.between({
        from: '10-11-2024',
        to: '12-31-2024',
      });
      const endDate = faker.date.future({ refDate: initDate });

      return {
        id: idx + 1,
        name: faker.commerce.productName(),
        code: faker.string.alphanumeric({ length: 7 }),
        client: faker.company.name(),
        personal_pos: faker.number.int({ min: 1, max: 12 }),
        activities: faker.number.int({ min: 1, max: 5 }),
        init_date: initDate,
        end_date: endDate,
        progress: faker.number.int({ min: 0, max: 100 }),
      };
    });

    return HttpResponse.json({
      message: 'Campaign fetched successfully',
      campaigns: mockCampaigns,
    });
  }),

  //
  http.post(`${import.meta.env.VITE_API_URL}/campaign`, async ({ request }) => {
    try {
      const campaign = (await request.json()) as Campaign;
      const createdCampaign = {
        ...campaign,
        id: faker.string.uuid(),
        pointSalePersonal: faker.number.int({ min: 1, max: 12 }),
        activities: 0,
        progress: 0,
      };

      return HttpResponse.json(
        {
          message: 'Campaign created successfully',
          campaign: createdCampaign,
        },
        { status: 201 }
      );
    } catch {
      return HttpResponse.json(
        { message: 'Invalid campaign data format' },
        { status: 400 }
      );
    }
  }),

  // Create survey
  http.post(`${import.meta.env.VITE_API_URL}/survey`, async () => {
    try {
      return HttpResponse.json(
        {
          message: 'Survey created successfully',
          data: {},
        },
        { status: 201 }
      );
    } catch {
      return HttpResponse.json(
        { message: 'Invalid campaign data format' },
        { status: 400 }
      );
    }
  }),

  // Get campaign personal
  http.get(`${import.meta.env.VITE_API_URL}/:idCampaign/personal`, () => {
    return HttpResponse.json({
      message: 'Personal fetched successfully',
      data: {
        personal: {
          registered: Array.from(
            { length: faker.number.int({ min: 5, max: 10 }) },
            () => ({
              id: faker.string.uuid(),
              name: faker.person.fullName(),
              role: faker.helpers.arrayElement([
                'merchant',
                'supervisor',
                'cargo',
              ]),
            })
          ),
          nonRegistered: Array.from(
            { length: faker.number.int({ min: 1, max: 3 }) },
            () => ({
              id: faker.string.uuid(),
              name: faker.person.fullName(),
              role: faker.helpers.arrayElement([
                'merchant',
                'supervisor',
                'cargo',
              ]),
            })
          ),
        },
      },
    });
  }),
];
